import "./style.less";
export default function UserBookingDetails() {
    return {
        restrict: "E",
        scope: {
            booking: "<",
            bpCompletedOn: "<",
        },
        template: require("./template.html"),

        controller: ($scope) => {
            if (
                $scope.booking.payments != null &&
                $scope.booking.payments.length > 0
            ) {
                /* 
                    compare createdOn from payments array with
                    completedOn from bookings period
                    if match then set orderId
                    if no match then orderId we take the last payment id 
                */

                $scope.orderId = null;

                let paymentDate = new Date($scope.bpCompletedOn);
                paymentDate.setHours(0, 0, 0, 0);

                angular.forEach($scope.booking.payments, function (payment) {
                    let periodDate = new Date(payment.createdOn);
                    periodDate.setHours(0, 0, 0, 0);
                    if (paymentDate.getTime() === periodDate.getTime()) {
                        $scope.orderId = payment.id;
                    }
                });

                if (!$scope.orderId) {
                    $scope.orderId =
                        $scope.booking.payments[
                            $scope.booking.payments.length - 1
                        ].id;
                }
            }
        },
    };
}
